<template>
  <div></div>
</template>

<script>
import { getInfoByIdcard } from "@/api/attest";

export default {
  data() {
    return {
      userInfo: {},
      showMenu: false,
    };
  },
  methods: {
    // this.$route.query.idcard
    getInfo() {
      getInfoByIdcard({
        areaName: this.$route.query.areaName,
        idcard: this.$route.query.idcard,
        t: this.$route.query.t,
        sign: this.$route.query.sign,
      }).then((res) => {
        if (res.data && res.data.benefitUserInfo.haveFace) {
          this.$router.replace({
            path: "/record",
            query: {
              areaName: this.$route.query.areaName,
              idcard: this.$route.query.idcard,
              t: this.$route.query.t,
              sign: this.$route.query.sign,
            },
          });
        } else {
          this.$router.replace("/face");
        }
      });
    },
  },
  created() {
    this.getInfo();
  },
};
</script>

<style lang="scss" scoped>
</style>